var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"pa-4"},[_c('h3',[_vm._v("Battle Net Authorization is processing. Please wait...")]),_c('v-progress-circular',{staticClass:"ml-3",attrs:{"value":100,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }